import { defineStyle } from "@chakra-ui/react";

export const ExperientialComponentStyles = () => {
  return {
    mainContainer: defineStyle({
      display: "flex",
      flexDirection: "column",
      //   overflowY: "auto",
      height: { base: "calc(100vh - 50px)", md: "calc(100vh - 60px)" },
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }),
    subContainer: defineStyle({
      display: "grid",
      gridTemplateColumns: "repeat(14, 1fr)",
      gap: "24px",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      position: "relative",
      flexGrow: "1",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }),
    topContainer: defineStyle({
      gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
      display: "flex",
      flexDirection: "column",
      p: "20px",
      overflow: "auto",
      flexGrow: "1",
      position: "relative",
    }),
    lottieVin: defineStyle({
      width: "50px",
      height: "50px",
      marginTop: "28px",
      marginLeft: "60px",
      zIndex: 1,
      gridColumn: { base: "1/3", md: "1/2", lg: "2/3", xl: "2/3" },
    }),
    lottieVinVariant: defineStyle({
      width: "50px",
      height: "50px",
      zIndex: 1,
    }),
    emotionalScriptRow: defineStyle({
      display: "flex",
      flexDirection: "row",
    }),
    experientialBody: defineStyle({
      marginLeft: { base: "40px", md: "40px", lg: "50px" },
      marginTop: "16px",
    }),
    bottomInput: defineStyle({
      display: "grid",
      gridTemplateColumns: "repeat(14, 1fr)",
      gap: "24px",
      width: "100%",
    }),
    bottomEditor: defineStyle({
      gridColumn: { base: "1/15", md: "2/14", lg: "3/15" },
      position: "sticky",
      bottom: "1px",
      left: 0,
      zIndex: "1",
    }),
    bottomBox: defineStyle({
      height: { base: "10px", md: "28px" },
    }),
    experientialBodyContainer: defineStyle({
      width: "100%",
      marginBottom: "20px",
    }),
    experientialBodyContentContainer: defineStyle({
      marginBottom: "16px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "18px",
      minHeight: "42px",
      display: "flex",
      flexDirection: "column",
      borderRadius: "4px 16px 16px 16px",
      padding: "12px",
      bgColor: "#d9d6ed",
      maxWidth: "100%",
      alignItems: "flexStart",
      //   overflow: "auto",
    }),
    experientialBodyContentTitle: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "18px",
      lineHeight: "27px",
      marginBottom: "12px",
      color: "#362F8C",
    }),
    experientialDescriptionWord: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "20px",
      lineHeight: "30px",
      marginBottom: "12px",
      color: "#362F8C",
    }),
    experientialDescriptionContainer: defineStyle({
      display: "flex",
      flexDirection: "column",
      width: "100%",
    }),
    experientialBodyDescriptionContent: defineStyle({
      fontFamily: "Poppins, Text-lg/Regular",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "18px",
      marginBottom: "12px",
      color: "#362F8C",
    }),
    experientialBodyImagesContent: defineStyle({
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "12px",
      width: "100%",
    }),
    experientialBodyImagesContainer: defineStyle({
      width: "100%",
      marginTop: "16px",
    }),
    experientialBodyImage: defineStyle({
      cursor: "pointer",
      width: "240px",
      height: "240px",
      padding: "4px",
      borderRadius: "12px",
      objectFit: "cover",
    }),
    experientialBodyDownloadContainer: defineStyle({
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "18px",
      marginBottom: "16px",
      minHeight: "42px",
      display: "flex",
      borderRadius: "4px 16px 16px 16px",
      flexDirection: "column",
      padding: "12px",
      bgColor: "#d9d6ed",
      width: "100%",
      alignItems: "flexStart",
    }),
  };
};
